var _clipPath, _clipPath2, _clipPath3, _clipPath4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2345.32,-640.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612,157.889L639,184.889L639,256.889L567,256.889L567,157.889L612,157.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567,256.889L567,157.889L639,157.889L639,256.889L567,256.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612,157.889L639,184.889L639,256.889L567,256.889L567,157.889L612,157.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.458,178.664C591.665,178.664 590.351,178.787 589.518,179.034C588.286,179.403 587.349,179.905 586.706,180.542C586.061,181.179 585.617,182.02 585.371,183.067C585.125,184.114 585.002,185.964 585.002,188.618C585.002,190.247 584.947,191.39 584.838,192.046C584.701,192.923 584.447,193.652 584.078,194.232C583.709,194.815 583.27,195.228 582.764,195.473C582.259,195.72 581.505,195.871 580.507,195.926L580.507,200.852C581.766,200.921 582.701,201.19 583.309,201.662C583.917,202.134 584.373,202.918 584.674,204.013C584.892,204.765 585.002,206.4 585.002,208.918C585.002,211.079 585.117,212.663 585.351,213.669C585.584,214.675 586.038,215.52 586.715,216.204C587.392,216.888 588.225,217.377 589.209,217.672C590.194,217.966 591.61,218.112 593.458,218.112L594.546,218.112L594.546,213.186C593.068,213.186 592.106,213.094 591.662,212.91C591.218,212.725 590.885,212.455 590.667,212.099C590.449,211.744 590.338,211.114 590.338,210.211C590.338,209.581 590.29,208.132 590.194,205.859C590.112,204.368 589.936,203.179 589.661,202.288C589.387,201.4 588.994,200.644 588.48,200.02C587.968,199.397 587.308,198.855 586.5,198.388C587.416,197.801 588.099,197.233 588.542,196.685C588.986,196.138 589.353,195.444 589.64,194.601C589.927,193.761 590.106,192.662 590.174,191.307C590.297,188.9 590.359,187.264 590.359,186.401C590.359,185.554 590.462,184.955 590.667,184.607C590.872,184.257 591.19,183.997 591.621,183.826C592.052,183.655 593.027,183.569 594.546,183.569L594.546,178.664L593.458,178.664Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.507,218.112L580.507,178.664L594.546,178.664L594.546,218.112L580.507,218.112Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.763,178.664L610.763,183.569C612.31,183.569 613.305,183.662 613.749,183.847C614.193,184.032 614.501,184.296 614.673,184.636C614.845,184.979 614.937,185.663 614.95,186.689C615.019,189.946 615.127,192.053 615.279,193.011C615.512,194.407 615.948,195.556 616.592,196.459C617.056,197.089 617.796,197.731 618.808,198.388C618.028,198.84 617.389,199.363 616.89,199.958C616.389,200.554 615.989,201.28 615.688,202.134C615.388,202.989 615.203,204.129 615.135,205.552C615.024,207.905 614.968,209.499 614.96,210.334C614.953,211.168 614.845,211.761 614.632,212.11C614.419,212.458 614.088,212.725 613.635,212.91C613.184,213.094 612.228,213.186 610.763,213.186L610.763,218.112L611.851,218.112C613.643,218.112 614.957,217.99 615.791,217.743C617.036,217.374 617.98,216.871 618.624,216.235C619.267,215.599 619.709,214.753 619.947,213.7C620.186,212.645 620.307,210.792 620.307,208.138C620.307,206.524 620.361,205.388 620.471,204.731C620.622,203.856 620.878,203.127 621.24,202.545C621.602,201.964 622.038,201.55 622.543,201.304C623.05,201.057 623.803,200.907 624.802,200.852L624.802,195.926C623.542,195.858 622.606,195.587 621.99,195.114C621.374,194.643 620.915,193.861 620.614,192.764C620.41,191.999 620.307,190.363 620.307,187.859C620.307,185.698 620.186,184.114 619.947,183.107C619.709,182.103 619.253,181.254 618.583,180.562C617.913,179.872 617.084,179.382 616.099,179.095C615.114,178.808 613.698,178.664 611.851,178.664L610.763,178.664Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.763,218.112L610.763,178.664L624.802,178.664L624.802,218.112L610.763,218.112Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612,184.888L639,184.888L612,157.888L612,184.888Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.5,171.388L612,157.888L639,184.888L625.5,198.388L598.5,171.388Z",
    style: {
      fill: "url(#_Linear8)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612,157.889L639,184.889L612,184.889L612,157.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "573px",
    y: "249.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "rgb(76,108,123)"
    }
  }, "CSS"))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-99,99,-4.3e-06,603,256.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(200,212,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.7e-06,-39.4482,39.4482,-1.7e-06,587.526,218.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(134,155,166)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(64,98,113)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.7e-06,-39.4482,39.4482,-1.7e-06,617.782,218.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(134,155,166)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(64,98,113)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,612,184.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81%",
    style: {
      stopColor: "rgb(197,209,216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(146,166,177)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.a2467576b6abbcddea413ea942431c79.svg";
export { ForwardRef as ReactComponent };